export const groupByXYDifference = (
  coordinates: any[],
  maxXDifference: number,
  maxYDifference: number,
) => {
  const groupedLists = [];
  let currentGroup = [coordinates[0]];

  for (let i = 1; i < coordinates.length; i++) {
    const xDifference = Math.abs(coordinates[i]?.x - coordinates[i - 1]?.x);
    const yDifference = Math.abs(coordinates[i]?.y - coordinates[i - 1]?.y);

    if (xDifference < maxXDifference && yDifference < maxYDifference) {
      // add object to the list
      currentGroup.push(coordinates[i]);
    } else {
      // create new list or push individual element
      groupedLists.push(
        currentGroup.length > 1 ? currentGroup : currentGroup[0],
      );
      currentGroup = [coordinates[i]]; // start a new group
    }
  }

  // add last item to the list
  groupedLists.push(currentGroup.length > 1 ? currentGroup : currentGroup[0]);

  return groupedLists;
};
